import React from 'react'
import { BqIcon } from '@beeq/react'
import PropTypes from 'prop-types'

import { StyledBqDropdown, StyledBqButton, OptionList } from './styles'

export const ActionsMenu = ({ children, panelHeight, placement, ...props }) => {
  return (
    <StyledBqDropdown panelHeight={panelHeight} placement={placement} data-testid='actions-column-dropdown' {...props}>
      <StyledBqButton slot='trigger' appearance='text' data-testid='actions-column-three-dots-btn'>
        <BqIcon name='dots-three-vertical' />
      </StyledBqButton>

      <OptionList data-testid='actions-role-list'>{children}</OptionList>
    </StyledBqDropdown>
  )
}

ActionsMenu.propTypes = {
  children: PropTypes.element,
  panelHeight: PropTypes.number,
  placement: PropTypes.string
}
